/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum SsoProvider {
  GOOGLE="GOOGLE",
APPLE="APPLE"
}

/**
* SsoProvider
*/
export const SsoProviderEnumType = types.enumeration("SsoProvider", [
        "GOOGLE",
  "APPLE",
      ])
